import { useTableConfigContext } from '../context/DataTableContext';

export function useTableSearchControl() {
  const { tableSearch } = useTableConfigContext();
  return tableSearch;
}
